import { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import Hero from '@/components/Hero';
import { Services } from '@/components/Services'
import { Portfolio } from '@/components/Portfolio'
import { About } from '@/components/About'
import { Contact } from '@/components/Contact'
import { Footer } from '@/components/Footer'
import { Pricing } from '@/components/Pricing'
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

const Index = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Prioritize scrolling to a section if directed by navigation state.
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        element.scrollIntoView();
        // Clear state to prevent re-scrolling on refresh.
        window.history.replaceState({}, '');
        return;
      }
    }

    // Otherwise, restore scroll position from session storage on refresh.
    const savedPosition = sessionStorage.getItem('scrollPosition');
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition, 10));
    }
  }, [location]);

  // Remove the loading screen once the page renders
  useEffect(() => {
    const loader = document.getElementById('loading-screen');
    if (loader) {
      loader.style.opacity = '0';
      setTimeout(() => loader.remove(), 300);
    }
  }, []);

  // Effect to save scroll position to session storage.
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          sessionStorage.setItem('scrollPosition', window.scrollY.toString());
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.div
      className="min-h-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 1, transition: { duration: 0.5 } }}
    >
      <Helmet>
        <title>Pyksel: Brand & Web Design | Moderne nettsider som konverterer</title>
        <meta name="description" content="Pyksel er et designbyrå spesialisert i brand design og web design. Vi bygger moderne, lynraske nettsider som konverterer besøkende til kunder." />
      </Helmet>
      <Navigation />
      
      <main>
        <section id="home">
          <Hero />
        </section>
        
        <section id="tjenester">
          <Services />
        </section>

        <section id="priser">
          <Pricing />
        </section>
        
        <Portfolio />
        
        <section id="about">
          <About />
        </section>
        
        <section id="contact">
          <Contact />
        </section>
      </main>
      
      <Footer />
    </motion.div>
  );
};

export default Index;
